var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    !_vm.cseit._id
      ? _c("div", [
          _c("p", [
            _vm._v(
              "CSE-IT not found, or you do not have access to this CSE-IT in the given Org/Group context."
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.cseit._id
      ? _c(
          "div",
          { staticClass: "personPage" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { sm: "9" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "b-tabs",
                        {
                          staticClass: "cseit-tabs",
                          model: {
                            value: _vm.tabIndex,
                            callback: function($$v) {
                              _vm.tabIndex = $$v
                            },
                            expression: "tabIndex"
                          }
                        },
                        [
                          _c(
                            "b-tab",
                            {
                              staticClass: "introTab",
                              attrs: { title: "Introduction" }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "p",
                                      { staticClass: "introduction-text" },
                                      [
                                        _c("b", [
                                          _vm._v("Pre-CSE-IT Assessment")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "introduction-text pt-4 pb-4"
                                      },
                                      [
                                        _vm._v(
                                          "Based on your professional judgment and the information available to you at the time of screening, "
                                        ),
                                        _c("b", [
                                          _vm._v(
                                            "including information not assessed on the screening tool, "
                                          )
                                        ]),
                                        _vm._v(
                                          "do you believe the youth is being, or has been, commercially sexually exploited?"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("h5", [
                                      _c("b", [
                                        _vm._v(_vm._s(_vm.cseit.judge_before))
                                      ])
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            { attrs: { title: "Questionnaire" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "b-tabs",
                                          {
                                            staticClass:
                                              "nestedTabs withTable fontSize-xs",
                                            attrs: {
                                              "active-nav-item-class":
                                                "font-weight-bold text-uppercase"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-tab",
                                              { attrs: { title: "HOUSING" } },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered"
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "1. HOUSING AND CAREGIVING.  The youth experiences housing or caregiving instability for any reason."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No Information"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("No Concern")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Possible Concern"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Clear Concern"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.filterQuestions(
                                                          "1"
                                                        ),
                                                        function(
                                                          question,
                                                          index
                                                        ) {
                                                          return _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    question.order.split(
                                                                      "."
                                                                    )[1]
                                                                  ) +
                                                                    ". " +
                                                                    _vm._s(
                                                                      question.questionText
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Information",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Possible Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("1")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Clear Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("2")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("tfoot", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-10"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Indicator 1 Score:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  A subtotal of 4-5 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".  A subtotal ≥ 6 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ]),
                                                            _vm._v(".")
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", {
                                                          staticClass:
                                                            "col-sm-6"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q1 ===
                                                              "No Concern" ||
                                                            _vm.cseit
                                                              .calc_q1 === ""
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "No Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q1 ===
                                                            "Possible Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Possible Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q1 ===
                                                            "Clear Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Clear Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tab",
                                              {
                                                attrs: { title: "PRIOR ABUSE" }
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered"
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "2. PRIOR ABUSE AND TRAUMA. The youth has experienced trauma (not including exploitation)."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No Information"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("No Concern")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Possible Concern"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Clear Concern"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.filterQuestions(
                                                          "2"
                                                        ),
                                                        function(
                                                          question,
                                                          index
                                                        ) {
                                                          return _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    question.order.split(
                                                                      "."
                                                                    )[1]
                                                                  ) +
                                                                    ". " +
                                                                    _vm._s(
                                                                      question.questionText
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Information",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Possible Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("1")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Clear Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("2")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("tfoot", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-10"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Indicator 2 Score:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  A subtotal of 2 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".  A subtotal ≥ 3 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ]),
                                                            _vm._v(".")
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", {
                                                          staticClass:
                                                            "col-sm-6"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q2 ===
                                                              "No Concern" ||
                                                            _vm.cseit
                                                              .calc_q2 === ""
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "No Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q2 ===
                                                            "Possible Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Possible Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q2 ===
                                                            "Clear Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Clear Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tab",
                                              {
                                                attrs: {
                                                  title: "PHYSICAL HEALTH"
                                                }
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered"
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "3. PHYSICAL HEALTH AND APPEARANCE. The youth experiences notable changes in health and appearance."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No Information"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("No Concern")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Possible Concern"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Clear Concern"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.filterQuestions(
                                                          "3"
                                                        ),
                                                        function(
                                                          question,
                                                          index
                                                        ) {
                                                          return _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    question.order.split(
                                                                      "."
                                                                    )[1]
                                                                  ) +
                                                                    ". " +
                                                                    _vm._s(
                                                                      question.questionText
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Information",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Possible Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("1")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Clear Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("2")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("tfoot", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-10"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Indicator 3 Score:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  A subtotal of 2-3 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".  A subtotal ≥ 4 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ]),
                                                            _vm._v(".")
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", {
                                                          staticClass:
                                                            "col-sm-6"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q3 ===
                                                              "No Concern" ||
                                                            _vm.cseit
                                                              .calc_q3 === ""
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "No Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q3 ===
                                                            "Possible Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Possible Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q3 ===
                                                            "Clear Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Clear Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tab",
                                              {
                                                attrs: { title: "ENVIRONMENT" }
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered"
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "4. ENVIRONMENT AND EXPOSURE. The youth's environment and activities place them at risk for exploitation."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No Information"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("No Concern")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Possible Concern"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Clear Concern"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.filterQuestions(
                                                          "4"
                                                        ),
                                                        function(
                                                          question,
                                                          index
                                                        ) {
                                                          return _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    question.order.split(
                                                                      "."
                                                                    )[1]
                                                                  ) +
                                                                    ". " +
                                                                    _vm._s(
                                                                      question.questionText
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Information",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Possible Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("1")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Clear Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("2")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("tfoot", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-10"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Indicator 4 Score:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  A subtotal of 1 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".  A subtotal ≥ 2 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ]),
                                                            _vm._v(".")
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", {
                                                          staticClass:
                                                            "col-sm-6"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q4 ===
                                                              "No Concern" ||
                                                            _vm.cseit
                                                              .calc_q4 === ""
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "No Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q4 ===
                                                            "Possible Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Possible Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q4 ===
                                                            "Clear Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Clear Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tab",
                                              {
                                                attrs: {
                                                  title: "RELATIONSHIPS"
                                                }
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered"
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "5. RELATIONSHIPS AND PERSONAL BELONGINGS. The youth's relationships and personal belongings are not consistent with their age or circumstances, suggesting possible recruitment."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No Information"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("No Concern")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Possible Concern"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Clear Concern"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.filterQuestions(
                                                          "5"
                                                        ),
                                                        function(
                                                          question,
                                                          index
                                                        ) {
                                                          return _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    question.order.split(
                                                                      "."
                                                                    )[1]
                                                                  ) +
                                                                    ". " +
                                                                    _vm._s(
                                                                      question.questionText
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Information",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Possible Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("1")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Clear Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("2")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("tfoot", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-10"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Indicator 5 Score:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  A subtotal of 1-2 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".  A subtotal ≥ 3 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ]),
                                                            _vm._v(".")
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", {
                                                          staticClass:
                                                            "col-sm-6"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q5 ===
                                                              "No Concern" ||
                                                            _vm.cseit
                                                              .calc_q5 === ""
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "No Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q5 ===
                                                            "Possible Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Possible Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q5 ===
                                                            "Clear Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Clear Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tab",
                                              {
                                                attrs: {
                                                  title: "CURRENT TRAUMA"
                                                }
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered"
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "6. SIGNS OF CURRENT TRAUMA. The youth exhibits signs that may result from exposure to any trauma."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No Information"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("No Concern")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Possible Concern"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Clear Concern"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.filterQuestions(
                                                          "6"
                                                        ),
                                                        function(
                                                          question,
                                                          index
                                                        ) {
                                                          return _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    question.order.split(
                                                                      "."
                                                                    )[1]
                                                                  ) +
                                                                    ". " +
                                                                    _vm._s(
                                                                      question.questionText
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Information",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Possible Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("1")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Clear Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("2")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("tfoot", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-10"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Indicator 6 Score:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  A subtotal of 1-2 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".  A subtotal ≥ 3 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ]),
                                                            _vm._v(".")
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", {
                                                          staticClass:
                                                            "col-sm-6"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q6 ===
                                                              "No Concern" ||
                                                            _vm.cseit
                                                              .calc_q6 === ""
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "No Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q6 ===
                                                            "Possible Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Possible Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q6 ===
                                                            "Clear Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Clear Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tab",
                                              { attrs: { title: "COERCION" } },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered"
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "7. COERCION. The youth is being controlled or coerced by another person."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No Information"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("No Concern")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Possible Concern"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Clear Concern"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.filterQuestions(
                                                          "7"
                                                        ),
                                                        function(
                                                          question,
                                                          index
                                                        ) {
                                                          return _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    question.order.split(
                                                                      "."
                                                                    )[1]
                                                                  ) +
                                                                    ". " +
                                                                    _vm._s(
                                                                      question.questionText
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Information",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Possible Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("1")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Clear Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("2")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("tfoot", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-10"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Indicator 7 Score:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  A subtotal of 1 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".  A subtotal ≥ 2 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ]),
                                                            _vm._v(".")
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", {
                                                          staticClass:
                                                            "col-sm-6"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q7 ===
                                                              "No Concern" ||
                                                            _vm.cseit
                                                              .calc_q7 === ""
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "No Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q7 ===
                                                            "Possible Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Possible Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q7 ===
                                                            "Clear Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Clear Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tab",
                                              {
                                                attrs: { title: "EXPLOITATION" }
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered"
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "8. EXPLOITATION.  The youth exchanges sex for money or material goods, including food or shelter."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No Information"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("No Concern")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Possible Concern"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Clear Concern"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.filterQuestions(
                                                          "8"
                                                        ),
                                                        function(
                                                          question,
                                                          index
                                                        ) {
                                                          return _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-6"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    question.order.split(
                                                                      "."
                                                                    )[1]
                                                                  ) +
                                                                    ". " +
                                                                    _vm._s(
                                                                      question.questionText
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Information",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "No Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("0")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Possible Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("1")]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "col-sm-2 text-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-radio",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        "",
                                                                      value:
                                                                        "Clear Concern",
                                                                      name:
                                                                        question.fieldName
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .questionAnswers[
                                                                          question
                                                                            .id
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.questionAnswers,
                                                                          question.id,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "questionAnswers[question.id]"
                                                                    }
                                                                  },
                                                                  [_vm._v("2")]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("tfoot", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-10"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Indicator 8 Score:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  A subtotal of 1 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Possible Concern"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".  A subtotal ≥ 2 indicates "
                                                            ),
                                                            _c("em", [
                                                              _vm._v(
                                                                "Clear Concern"
                                                              )
                                                            ]),
                                                            _vm._v(".")
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", {
                                                          staticClass:
                                                            "col-sm-6"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q8 ===
                                                              "No Concern" ||
                                                            _vm.cseit
                                                              .calc_q8 === ""
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "No Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q8 ===
                                                            "Possible Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Possible Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "col-sm-2 text-center"
                                                          },
                                                          [
                                                            _vm.cseit
                                                              .calc_q8 ===
                                                            "Clear Concern"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Clear Concern"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              staticClass: "scoreTab",
                              attrs: { title: "Score" }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c("h4", [_vm._v("Summary:")]),
                                    _vm._v(" "),
                                    _c(
                                      "table",
                                      { staticClass: "table table-bordered" },
                                      [
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Indicators")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Indicator Score")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("No Information Summary")]
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tbody", [
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v(
                                                  "1. Housing and Caregiving"
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_q1
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cseit.calc_q1) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.calculateSummaryNumber(
                                                        _vm.cseit.calc_q1
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.questionOneNoInformationPercentage
                                                ) + "%"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v(
                                                  "2. Prior Abuse or Trauma"
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_q2
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cseit.calc_q2) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.calculateSummaryNumber(
                                                        _vm.cseit.calc_q2
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.questionTwoNoInformationPercentage
                                                ) + "%"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v(
                                                  "3. Physical Health and Appearance"
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_q3
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cseit.calc_q3) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.calculateSummaryNumber(
                                                        _vm.cseit.calc_q3
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.questionThreeNoInformationPercentage
                                                ) + "%"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v(
                                                  "4. Environment and Exposure"
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_q4
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cseit.calc_q4) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.calculateSummaryNumber(
                                                        _vm.cseit.calc_q4
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.questionFourNoInformationPercentage
                                                ) + "%"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v(
                                                  "5. Relationships and Personal Belongings"
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_q5
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cseit.calc_q5) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.calculateSummaryNumber(
                                                        _vm.cseit.calc_q5
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.questionFiveNoInformationPercentage
                                                ) + "%"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v(
                                                  "6. Signs of Current Trauma"
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_q6
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cseit.calc_q6) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.calculateSummaryNumber(
                                                        _vm.cseit.calc_q6
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.questionSixNoInformationPercentage
                                                ) + "%"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v("7. Coercion")
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_q7
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cseit.calc_q7) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.calculateSummaryNumber(
                                                        _vm.cseit.calc_q7
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.questionSevenNoInformationPercentage
                                                ) + "%"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v("8. Exploitation")
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_q8
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cseit.calc_q8) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.calculateSummaryNumberEight(
                                                        _vm.cseit.calc_q8
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.questionEightNoInformationPercentage
                                                ) + "%"
                                              )
                                            ])
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tfoot", [
                                          _c("tr", [
                                            _c("td", [
                                              _c("strong", [_vm._v("Total:")])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                class: _vm.calculationClass(
                                                  _vm.cseit.calc_cseitScore
                                                )
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.cseit.calc_cseitScore
                                                    ) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.cseitFinalScore
                                                      ) +
                                                      ")"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td")
                                          ])
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "introduction-text" },
                                      [
                                        _c("b", [
                                          _vm._v("CSE-IT Continuum of Concern")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("img", {
                                      attrs: {
                                        src: "static/img/cseit_scale.svg",
                                        height: "75"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "introduction-text" },
                                      [
                                        _c("b", [
                                          _vm._v("Post-CSE-IT Assessment")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "introduction-text" },
                                      [
                                        _vm._v(
                                          "Based on your professional judgment and the information available to you at the time of this CSE-IT, "
                                        ),
                                        _c("i", [
                                          _vm._v(
                                            "including information not assessed on the CSE-IT, "
                                          )
                                        ]),
                                        _vm._v(
                                          "do you believe the youth is being, or has been, commercially sexually exploited?"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("h5", [
                                      _c("b", [
                                        _vm._v(_vm._s(_vm.cseit.judge_after))
                                      ])
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _vm.cseit.judge_whynot
                                      ? _c("h5", [
                                          _vm._v(_vm._s(_vm.cseit.judge_whynot))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cseit.can_duration
                                      ? _c("h5", [
                                          _c("b", [_vm._v("Duration")])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cseit.can_duration
                                      ? _c("h5", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.capitalize(
                                                _vm.cseit.can_duration
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cseit.can_onset
                                      ? _c("h5", [_c("b", [_vm._v("Onset")])])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cseit.can_onset
                                      ? _c("h5", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.capitalize(
                                                _vm.cseit.can_onset
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cseit.can_perception
                                      ? _c("h5", [
                                          _c("b", [_vm._v("Perception")])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cseit.can_perception
                                      ? _c("h5", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.capitalize(
                                                _vm.cseit.can_perception
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cseit.comments
                                      ? _c("h5", [
                                          _c("b", [_vm._v("Comments")])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cseit.comments
                                      ? _c("h5", [
                                          _vm._v(_vm._s(_vm.cseit.comments))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("h5", { staticClass: "pt-4" }, [
                                      _c("b", [_vm._v("Location: ")]),
                                      _vm._v(_vm._s(_vm.cseit_location))
                                    ]),
                                    _vm._v(" "),
                                    _c("h5", [
                                      _c("b", [_vm._v("Program: ")]),
                                      _vm._v(_vm._s(_vm.cseit_program))
                                    ]),
                                    _vm._v(" "),
                                    _vm.isUserInTX &&
                                    _vm.cseit.calc_cseitScore ===
                                      "Clear Concern"
                                      ? _c("div", [
                                          _c("h5", { staticClass: "pt-4" }, [
                                            _c("b", [_vm._v("Next Steps")])
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "Refer the youth for appropriate services, which may include:"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("ul", [
                                            _c("li", [
                                              _c("b", [
                                                _vm._v("Care Coordination")
                                              ]),
                                              _vm._v(", and/or")
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c("b", [
                                                _vm._v(
                                                  "Commercially Sexually Exploited Youth (CSEY) Advocacy"
                                                )
                                              ])
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v("You may visit the "),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "http://gov.texas.gov/cstt",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "Office of the Governor Child Sex Trafficking Team website"
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " to locate the Care Coordination Team and CSEY Advocate Agency in your county. If you are unsure whether Care Coordination is available in your county, or need assistance identifying the designated CSEY Advocacy provider for your region, please contact the Child Sex Trafficking Team for guidance at: "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "mailto:cstt@gov.texas.gov"
                                                }
                                              },
                                              [_vm._v("cstt@gov.texas.gov")]
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "padding24" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  path: "/cseit/" + _vm.cseit.id + "/print",
                                  query: { id: _vm.cseit._id }
                                }
                              }
                            },
                            [
                              _c(
                                "b-button",
                                { attrs: { variant: "primary" } },
                                [
                                  _vm._v(
                                    "\n                Print\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { sm: "3" } },
                  [
                    _c("ShareCseitList", {
                      attrs: {
                        cseitId: _vm.cseit._id,
                        cseitOrganizationOwner: _vm.cseit.organizationOwner.id,
                        personId: _vm.cseit.person._id
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { attrs: { "no-body": "", title: _vm.cseit.id } },
                      [
                        _c("b-card-header", [_c("b", [_vm._v("Meta")])]),
                        _vm._v(" "),
                        _c("b-card-body", [
                          _c("p", { staticClass: "card-text" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-muted text-uppercase font-weight-bold"
                              },
                              [_vm._v("CSE-IT ID: ")]
                            ),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(" " + _vm._s(_vm.cseit.id) + " ")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "card-text" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-muted text-uppercase font-weight-bold"
                              },
                              [_vm._v("Person ID")]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "small",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/person/" + _vm.cseit.person.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.cseit.person.id) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-list-group",
                          { attrs: { flush: "" } },
                          [
                            _c(
                              "b-list-group-item",
                              { staticClass: "small text-muted" },
                              [
                                _c("b", [_vm._v("Created At: ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.getCreatedAt()) +
                                    "\n              "
                                ),
                                _vm._.isObject(_vm.cseit.createdBy)
                                  ? _c("div", [
                                      _c("b", [_vm._v(" by: ")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._.get(
                                              _vm.cseit,
                                              "createdBy.emailAddress",
                                              ""
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("b", [_vm._v("Last Updated: ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.getLastUpdateDate()) +
                                    "\n              "
                                ),
                                _vm._.isObject(_vm.cseit.updatedBy)
                                  ? _c("div", [
                                      _c("b", [_vm._v(" by: ")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._.get(
                                              _vm.cseit,
                                              "updatedBy.emailAddress",
                                              ""
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              { staticClass: "small text-muted" },
                              [
                                _c("p", [
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "text-muted text-uppercase font-weight-bold"
                                    },
                                    [_vm._v("Current Record Owner")]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("small", { staticClass: "text-muted" }, [
                                    _c("b", [_vm._v(" by: ")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._.get(
                                            _vm.cseit,
                                            "organizationOwner.title"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10ffc3a8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ffc3a8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/Cseit.vue
// module id = 1752
// module chunks = 0